// extracted by mini-css-extract-plugin
export default {"reviewsList":"Reviews_reviewsList__1BB-J","reviewsRow":"Reviews_reviewsRow__MRqI1"};